import api from "../../http";

export default class ApiIndexNewGames {
  static async getApiIndexNewGames(url) {
    return api.get(url)
  }
}